import Vue from 'vue'
import { ValidationObserver, ValidationProvider, extend, localize } from 'vee-validate';
import en from 'vee-validate/dist/locale/en.json';
import * as rules from 'vee-validate/dist/rules';
import App from './App.vue'
import routes from './routes';

import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import VueMask from 'v-mask'
// import AppProvider from "./AppProvider";
import Router from 'vue-router';
//import * as VueGoogleMaps from "vue2-google-maps";
import VueHtmlToPaper from "vue-html-to-paper";



import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});
en.messages.required = '{_field_} is required.';
en.messages.email = '{_field_} must be a valid email.';
localize({
    en: en
});

// Install components globally
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

Vue.config.productionTip = false
//Vue.component('ValidationProvider', ValidationProvider);
Vue.use(BootstrapVue);
Vue.use(VueMask);
Vue.use(Router);

const print_options = {
    name: '_blank',
    specs: [
        'fullscreen=no',
        'titlebar=no',
        'scrollbars=no'
    ],
    styles: [
        window.location.origin+'/styles/print_css.css',
    ]
}
Vue.use(VueHtmlToPaper,print_options);
// Vue.use(VueGoogleMaps, {
//   load: {
//     key: "AIzaSyC8i_mzqJMjYW1NR7NMzyISTRR4aP4Od1c",
//     libraries: "places" // necessary for places input
//   }
// });
//  const routes = {
//      '/' : App,
//     '/provider' : AppProvider ,
//     '/provider/:id' : AppProvider };

// const router = new Router({
//     routes
// });
const router = new Router({mode: 'history', routes});
console.log("router",router);
export default routes;



new Vue({
    router,
    render: h => h(App)
}).$mount('#app');
// new Vue({
//     el: '#app',
//     router,
//     template: '<App/>',
//     components: { App }
// })
